import { api } from "./api"

export const GET_ALL_RETELLS = async () => {
    const { data } = await api.get(`/retells`)
    return data.retells || [];
}

export const CONNECT_RETELL = async (params: any) => {
    const { data } = await api.post(`/retells`, params)
    return data;
}
